import * as Actions from '../../actions';

const initialState = { data: null };

const viewMonthlyReportsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ADMIN_MONTHLY_REPORTS:
            return { ...state, data: { ...action.payload } };

        case Actions.GET_PRODUCER_MONTHLY_REPORTS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default viewMonthlyReportsReducer;
